<template>
	<page>
		<module enable-flex>
<!--			<m-search ref="search" @search="searchHandle">-->
<!--				<c-form>-->
<!--					<c-form-item type="input" label="用户名" name="user_name"></c-form-item>-->
<!--					<c-form-item type="input" label="姓名" name="user_realname"></c-form-item>-->
<!--					<c-form-item type="input" label="部门" name="department"></c-form-item>-->
<!--					<c-form-item type="input" label="手机号" name="phone"></c-form-item>-->
<!--					<c-form-item type="select" label="用户类型" name="user_type" :options="userType"></c-form-item>-->
<!--					<c-form-item type="checkbox" name="state" :options="userState"></c-form-item>-->
<!--				</c-form>-->
<!--			</m-search>-->
			
			<m-operate>
        注意：验证码每月1号进行自动更新(暂不支持)
        <!--				<c-button color="sys" @click="createUser">新增用户</c-button>-->
			</m-operate>
			
			<c-table ref="table" code="system_verify_code_list">
				<c-table-column
					label="标题"
					name="type"
				>
				</c-table-column>
				
				<c-table-column
					label="验证码"
					name="verify_code"
				>
				</c-table-column>
				

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button @click="edit(data)">更新验证码</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

	</page>
</template>

<script>
	export default {
		name: 'm_system_verify_code',
		
		data() {
			return {
				// userType: [{
				// 	name: '系统用户',
				// 	value: 2
				// }],
        //
				// userState: [{
				// 	name: '启用',
				// 	value: 2
				// }, {
				// 	name: '禁用',
				// 	value: 1
				// }],
        //
				// editState: false
			}
		},
		
		mounted() {
      // this.$refs.methods.searchHandle();
      this.searchHandle();
		},
		
		methods: {
			searchHandle() {
				this.$refs.table.load({
					url: '/verify_code/list',
				});
			},
			//
			// createUser() {
			// 	this.editState = false;
			// 	this.$refs.userForm.clear();
			// 	this.$refs.userEdit.open();
			// },
			//
			edit(val) {
        this.$confirm({
          text: '确定更新【'+val.type+'】吗？',  // 提示内容,
          buttonName: '确定',  // 确定按钮文字
          cancelButton: true,  // 是否显示取消按钮
          resolve: () => {
            this.request({
              url: '/verify_code/update',
              data: {
                type: val.type
              },
              loading: true,
              success: (data,s)=> {
                this.$message({
                  text: '更新成功'
                });
                this.searchHandle();
              }
            });
          },  // 确定按钮回调
          cancel: () => {},  // 取消按钮回调
        });
      },
			//
			// submitUser(stop) {
			// 	stop();
			// 	this.$refs.userForm.submit({
			// 		url: '/sys_user/add',
			// 		rule: {
			// 			user_name: [{
			// 				type: 'empty',
			// 				word: '请填写用户名'
			// 			}],
			//
			// 			user_realname: [{
			// 				type: 'empty',
			// 				word: '请填写用户姓名'
			// 			}],
			//
			// 			user_type: [{
			// 				type: 'empty',
			// 				word: '请选择用户类型'
			// 			}],
			//
			// 			phone: [{
			// 				type: 'empty',
			// 				word: '请填写部门'
			// 			}],
			//
			// 			state: [{
			// 				type: 'empty',
			// 				word: '请选择用户类型'
			// 			}]
			// 		},
			// 		dataFormatter: data => {
			// 			return data;
			// 		}
			// 	});
			// }
		}
	}
</script>